module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "overflow-y": "auto"
    }
  }, [_c('v-carousel', {
    attrs: {
      "cycle": "",
      "interval": _vm.seconds * 1000,
      "hide-delimiters": "",
      "show-arrows": false,
      "height": "1000"
    }
  }, _vm._l((_vm.charts), function(chart, i) {
    return _c('v-carousel-item', {
      key: i,
      attrs: {
        "src": ''
      }
    }, [_c('div', {
      staticStyle: {
        "height": "100%",
        "overflow": "auto"
      }
    }, [_c(chart.type, {
      tag: "component",
      attrs: {
        "chart": chart,
        "tenantKey": _vm.tenantKey
      }
    })], 1)])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "pa-2"
  }, [_vm._v("\n    Speed: "), _vm._l((12), function(n) {
    return _c('a', {
      key: n,
      staticClass: "mr-3",
      on: {
        "click": function($event) {
          return _vm.setSpeed(n * 5)
        }
      }
    }, [_vm._v(_vm._s(n * 5) + " seconds")])
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fa9bd6e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Charts/ChartRotator.vue
// module id = 2597
// module chunks = 1